import OrderForm from '../pages/orders/order-edit/OrderForm';
import OrderDetails from '../pages/orders/order-view/OrderDetails';
import OrdersTablePage from '../pages/orders/orders-table/OrdersTablePage';
import PATHS from '../paths';

export const ORDERS_ROUTES = [
  {
    index: true,
    element: <OrdersTablePage />
  },
  {
    path: PATHS.ORDER_VIEW,
    element: <OrderDetails />
  },
  {
    path: PATHS.ORDER_EDIT,
    element: <OrderForm />
  }
];
